<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="vehicle.pkId ? '编辑' : '新建'"
    width="600px"
    @close="$reset('form')"
  >
    <el-form ref="form" :model="vehicle" :rules="ruleValidate" class="form" label-width="80px">
      <el-row>
        <el-col v-if="vehicle.pkId">
          <el-form-item label="载具编号" prop="vehicleNo">
            <el-input v-model="vehicle.vehicleNo" disabled placeholder="请输入载具编号" />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="载具名称" prop="vehicleName">
            <el-input v-model="vehicle.vehicleName" placeholder="请输入载具名称" />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="长度单位" prop="cubicUnitName">
            <el-input v-model="vehicle.cubicUnitName" placeholder="请选择长度单位" readonly>
              <el-button slot="append" @click="$refs.selectCubicUnit.open()" icon="el-icon-search"></el-button>
            </el-input>
            <unit-select ref="selectCubicUnit" @select="selectCubicUnit" />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="长度" prop="length">
            <el-input v-model="vehicle.length" placeholder="请输入长度" />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="宽度" prop="width">
            <el-input v-model="vehicle.width" placeholder="请输入宽度" />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="限长" prop="lengthLimit">
            <el-input v-model="vehicle.lengthLimit" placeholder="请输入限长" />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="限宽" prop="widthLimit">
            <el-input v-model="vehicle.widthLimit" placeholder="请输入限宽" />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="载重单位" prop="loadUnitName">
            <el-input v-model="vehicle.loadUnitName" placeholder="请选择载重单位" readonly>
              <el-button slot="append" @click="$refs.selectLoadUnit.open()" icon="el-icon-search"></el-button>
            </el-input>
            <unit-select ref="selectLoadUnit" @select="selectLoadUnit" />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="载重" prop="load">
            <el-input v-model="vehicle.load" placeholder="请输入载重" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UnitSelect from "@/views/information/Unit/UnitSelect";
export default {
  components: { UnitSelect },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      vehicle: {
        pkId: 0,
        vehicleName: "",
        width: "",
        length: "",
        lengthLimit: "",
        widthLimit: "",
        cubicUnitId: "",
        cubicUnitName: "",
        load: "",
        loadUnitId: "",
        loadUnitName: "",
      },
      ruleValidate: {
        vehicleName: { required: true, message: "请输入载具名称", trigger: "blur" },
      },
    };
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      if (row) {
        this.vehicle = Object.assign(this.vehicle, row);
      }
    },

    // 确定
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .save("basic", "vehicles", this.vehicle)
            .then((resp) => {
              this.submitLoading = false;
              if (resp.success) {
                if (this.vehicle.pkId > 0) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                } else {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },

    // 选择长度单位
    selectCubicUnit(row) {
      this.vehicle.cubicUnitId = row.pkId;
      this.vehicle.cubicUnitName = row.unitName;
    },

    // 选择载重单位
    selectLoadUnit(row) {
      this.vehicle.loadUnitId = row.pkId;
      this.vehicle.loadUnitName = row.unitName;
    },
  },
};
</script>
